import { TourConfig } from 'components/tour/tour.types';

export const REQUEST_PAGE_TOUR_CONFIG: TourConfig = {
  id: 'request-page-tour',
  version: 2,
  steps: [
    {
      target: 'request-page-navigation',
      title: 'Удобная навигация',
      description:
        'Используйте меню слева, чтобы быстро переходить к нужным разделам. Навигацию можно свернуть — тогда она станет компактной, но останется под рукой.',
      side: 'right',
    },
    {
      target: 'request-page-edit-button',
      title: 'Редактирование в одном месте',
      description:
        'Изменение тела заявки и смена статуса теперь доступны прямо здесь. Нажмите «Редактировать», чтобы обновить информацию одним движением.',
      side: 'top',
      align: 'end',
    },
    {
      target: 'request-page-more-button',
      title: 'Все дополнительные действия рядом',
      description:
        'Копирование, удаление, чат, контроль и преобразование в обращение — всё собрано в кнопке «Ещё». Действия всегда доступны, когда понадобятся.',
      side: 'top',
    },
  ],
};
